// Display names for the material filter chips and the per-card material tags.
// The DB (materialAttributes.name_bg) stores these with a "100% памук - " prefix; the shop copy and
// the SEO pages both call them plainly "Ранфорс" and "Памучен сатен", so normalise on the way out.
// Matching is on the substring rather than the row id so an unrecognised material falls through to
// its stored name untouched.
const MATERIAL_LABEL_RULES = [
  { match: 'сатен', label: 'Памучен сатен' },
  { match: 'ранфорс', label: 'Ранфорс' }
];

export const materialDisplayName = (name) => {
  const normalized = (name || '').toLowerCase();
  const rule = MATERIAL_LABEL_RULES.find((r) => normalized.includes(r.match));
  return rule ? rule.label : name;
};
